import { ApiError, getAccessTokenForDownload } from './api'

const BASE = (import.meta.env.VITE_API_URL ?? 'http://localhost:3000') + '/api'

export interface UploadedImage {
  url: string
  thumbUrl: string
  key: string
}

/**
 * الرفع يستعمل FormData لا JSON، فلا يمرّ عبر دالة `api` التي تفرض
 * `Content-Type: application/json` — تحديد النوع يدوياً يُفسد حدّ الأقسام.
 */
export const uploadsApi = {
  async productImage(file: File): Promise<UploadedImage> {
    const body = new FormData()
    body.append('file', file)

    const res = await fetch(`${BASE}/uploads/product-image`, {
      method: 'POST',
      headers: { Authorization: `Bearer ${getAccessTokenForDownload()}` },
      body,
    })

    if (!res.ok) {
      let message = 'تعذّر رفع الصورة'
      let code: string | undefined
      try {
        const data = await res.json()
        message = data.message ?? message
        code = data.code
      } catch { /* ردّ غير JSON — نُبقي الرسالة العامة */ }
      throw new ApiError(res.status, message, code)
    }

    return res.json()
  },

  async removeProductImage(url: string): Promise<void> {
    await fetch(`${BASE}/uploads/product-image?url=${encodeURIComponent(url)}`, {
      method: 'DELETE',
      headers: { Authorization: `Bearer ${getAccessTokenForDownload()}` },
    })
  },
}
